import { useTranslation } from "react-i18next";

import { IconButton, LoadingIndicator, Tooltip } from "@digital-services/ui";

import { OrganizationStatus } from "@organization/models/OrganizationDetails";
import { OrganizationUser } from "@organization/models/OrganizationUser";
import { useGetOrganizationDetails } from "@organization/services/use-organization";

import { useDrawerWithConfirm } from "@hooks/useDrawerWithConfirm";
import { useUserContext } from "@hooks/useUserContext";
import EditIcon from "@icons/edit.svg?react";

import { EditUserForm } from "./EditUserForm";

interface Props {
  organizationUser: OrganizationUser; // TBD Introduce context
}

export function EditUserButton(props: Readonly<Props>) {
  const { organizationUser } = props;

  const { user } = useUserContext();
  const { organization, isLoading } = useGetOrganizationDetails();

  const { t } = useTranslation(undefined, { keyPrefix: "organization.users" });

  const { showDrawer, hideDrawer } = useDrawerWithConfirm();

  const editUser = (): void => {
    showDrawer({
      title: t("edit.title"),
      children: (
        <EditUserForm
          organizationUser={organizationUser}
          onCancel={hideDrawer}
          onSuccess={() => {
            hideDrawer();
          }}
        />
      )
    });
  };

  if (!user.isAdministrator) return null;

  const orgInactive = organization?.status === OrganizationStatus.Inactive;

  return (
    <Tooltip message={orgInactive ? "" : t("edit.tooltip")}>
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <IconButton
          disabled={orgInactive}
          onClick={editUser}
          data-testid={`edit-user-button-${organizationUser.id}`}
        >
          <EditIcon />
        </IconButton>
      )}
    </Tooltip>
  );
}
